<template>
	<Button v-if="currentStep == -1" class="user-link__activate-button" size="large" type="primary" @click="onStartSelectMaster()">
		<a-icon type="link" />
		Объединить двух пользователей
	</Button>

	<div v-else class="user-link__content">
		<h3>
			Объединение
			<Button @click="onCancel()">Закрыть</Button>
		</h3>

		<p>
			<strong>Поглотит</strong>
			- от него будет взята вся информация, в том числе OOHDESK ID
			<br />
			<strong>Будет поглощен</strong>
			- от него возьмутся аккаунты и привязанные продукты
		</p>

		<a-radio-group :value="currentStep" @change="currentStep == 0 ? onStartSelectSlave() : onStartSelectMaster()">
			<a-radio-button :value="0">
				Поглотит:
				<a-tag v-if="selectedMasterUserId" closable @close="onRemoveSelectedMasterUser">{{ selectedMasterUserId }}</a-tag>
				<span v-else>Не выбрано</span>
				<br />
			</a-radio-button>

			<a-radio-button :value="1">
				Будет поглощен:
				<a-tag v-if="selectedSlaveUserId" closable @close="onRemoveSelectedSlaveUser">{{ selectedSlaveUserId }}</a-tag>
				<span v-else>Не выбрано</span>
			</a-radio-button>
		</a-radio-group>

		<br />
		<br />

		<p v-if="selectedMasterUserId && selectedSlaveUserId">
			Какая строка получится в итоге:
			<UserTable :users="mergedUser ? [mergedUser] : []" :hasActions="false" />
		</p>

		<Button
			v-if="selectedMasterUserId && selectedSlaveUserId"
			:loading="isCompleting"
			class="user-link__complete"
			type="primary"
			@click="onComplete()"
		>
			Закончить объединение
		</Button>
	</div>
</template>

<script>
import { Button } from "ant-design-vue"

export default {
	name: "UserLink",

	components: {
		Button,
		UserTable: () => import("@/components/UserTable")
	},

	data() {
		return {
			/**
			 * -1 - не начато
			 * 0 - первый пользователь
			 * 1 - второй пользователь
			 */
			currentStep: -1,
			selectedMasterUser: null,
			selectedSlaveUser: null,
			isCompleting: false
		}
	},

	computed: {
		rowSelectionMaster() {
			return {
				type: "radio",
				selectedRowKeys: this.selectedMasterUserId ? [this.selectedMasterUserId] : [],
				onSelect: event => {
					this.selectedMasterUser = event
					this.$emit("set-row-selection", this.rowSelectionMaster)
				}
			}
		},

		rowSelectionSlave() {
			return {
				type: "radio",
				selectedRowKeys: this.selectedSlaveUserId ? [this.selectedSlaveUserId] : [],
				onSelect: event => {
					this.selectedSlaveUser = event
					this.$emit("set-row-selection", this.rowSelectionSlave)
				}
			}
		},

		selectedMasterUserId() {
			return this.selectedMasterUser ? this.selectedMasterUser.id : null
		},

		selectedSlaveUserId() {
			return this.selectedSlaveUser ? this.selectedSlaveUser.id : null
		},

		mergedUser() {
			if (this.selectedMasterUser && this.selectedSlaveUser) {
				const mergedProducts = [
					...this.selectedMasterUser.products.filter(
						masterProduct => !this.selectedSlaveUser.products.map(p => p.id).includes(masterProduct.id)
					),
					...this.selectedSlaveUser.products
				]

				const mergedUsers = [...this.selectedMasterUser.producterUsers, ...this.selectedSlaveUser.producterUsers]
				const mergedSessions = []

				return {
					...this.selectedMasterUser,
					products: mergedProducts,
					producterUsers: mergedUsers,
					sessions: mergedSessions
				}
			}

			return null
		}
	},

	methods: {
		isAllow(selectedRow) {
			return row => {
				if (!selectedRow) return true
				if (selectedRow.id == row.id) return false

				const masterUsers = selectedRow.producterUsers.map(u => u.product_id)
				return !row.producterUsers.some(rowUser => masterUsers.includes(rowUser.product_id))
			}
		},

		onStartSelectMaster() {
			this.currentStep = 0

			const isAllow = this.isAllow(this.selectedSlaveUser)
			this.$emit("set-filter-function", isAllow)

			this.$emit("set-row-selection", this.rowSelectionMaster)
		},

		onStartSelectSlave() {
			this.currentStep = 1

			const isAllow = this.isAllow(this.selectedMasterUser)
			this.$emit("set-filter-function", isAllow)

			this.$emit("set-row-selection", this.rowSelectionSlave)
		},

		onRemoveSelectedMasterUser() {
			this.selectedMasterUser = null
			this.onStartSelectMaster()
		},

		onRemoveSelectedSlaveUser() {
			this.selectedSlaveUser = null
			this.onStartSelectSlave()
		},

		async onComplete() {
			this.isCompleting = true

			try {
				await this.$context.adminUserService.linkUsers(this.selectedMasterUserId, this.selectedSlaveUserId)

				this.$alert.success("Привязалось")
				this.onCancel()
				this.$emit("refresh")
			} catch (message) {
				this.$alert.error(message)
			}

			this.isCompleting = false
		},

		onCancel() {
			this.selectedMasterUser = null
			this.selectedSlaveUser = null
			this.currentStep = -1
			this.$emit("set-filter-function", null)
			this.$emit("set-row-selection", null)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars";

.user-link {
	&__activate-button {
		margin-bottom: 20px;
	}

	&__content {
		width: 100%;
		margin-bottom: 20px;
		padding: 10px;
		border: 1px solid $gray-light;
		border-radius: 5px;
		background: $gray-lightest;
	}

	&__complete {
		margin: 10px 0;
	}
}
</style>
